import { Component, OnInit, Input } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-nutrition-card',
  templateUrl: './nutrition-card.component.html',
  styleUrls: ['./nutrition-card.component.scss'],
  standalone: false,
})
export class NutritionCardComponent implements OnInit {
  // Data for the display
  @Input() macros: any;
  currentCalories: number = 1721;
  // totalCalories: number = 2213;

  proteinEaten: number = 78;
  // proteinTotal: number = 90;
  fatsEaten: number = 45;
  // fatsTotal: number = 70;
  carbsEaten: number = 95;
  // carbsTotal: number = 110;
  macroTotal: number = 270; // Total grams for all macros combined
  // Colors derived from iOS RGB values
  // R: 0.959, G: 0.844, B: 0.812 => #F4D7CF
  bgPrimaryColor: string = '#F4D7CF';
  // R: 0.957, G: 0.459, B: 0.318 => #F47551 (Orange/Red)
  bgSecondaryColor: string = '#91432dff';
  // R: 0.404, G: 0.741, B: 0.431 => #67BD6E (Green)
  proteinBarColor: string = '#67BD6E';
  carbsBarColor: string = '#5B9BD5';
  // R: 0.957, G: 0.459, B: 0.318 => #F47551 (Orange/Red)
  fatsBarColor: string = '#F47551';
  // R: 0.912, G: 0.912, B: 0.912 => #E8E8E8 (Light Gray)
  barGrayColor: string = '#E8E8E8';
  displayDate: any = moment();

  // Helper method to calculate percentage for CSS width
  getMacroPercentage(eaten: number, total: number): string {
    return `${(eaten / total) * 100}%`;
  }

  constructor() {}

  ngOnInit() {
    // if (this.macros) {
      this.proteinEaten = this.macros.protein || 0;
      this.fatsEaten = this.macros.fats || 0;
      this.carbsEaten = this.macros.carbs || 0;
      this.currentCalories = this.macros.calories || 0;
    // }
    this.macroTotal = this.proteinEaten + this.fatsEaten + this.carbsEaten;
  }
    getFormattedDisplayDate(): string {
      return moment(this.displayDate).format('dddd, MMMM D, YYYY');
    }
 getRatioGradient(): string {
    const total = this.proteinEaten + this.fatsEaten + this.carbsEaten;

    if (total === 0) {
      return 'linear-gradient(to right, var(--ion-fade-grey), var(--ion-fade-grey))';
    }

    const p1 = (this.fatsEaten / total) * 100;
    const p2 = (this.carbsEaten / total) * 100;
    const stop1 = p1; 
    const stop2 = p1 + p2;

    return `linear-gradient(to right, ${this.fatsBarColor} 0%, ${this.fatsBarColor} ${stop1}%, ${this.carbsBarColor} ${stop1}%, ${this.carbsBarColor} ${stop2}%, ${this.proteinBarColor} ${stop2}%, ${this.proteinBarColor} 100%)`;
  }
}